import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";
import * as React from "react";

export const PowerOffIcon = (props: SvgIconProps) => {
    const { viewBox = "0 0 24 24", ...rest } = props;

    return (
        <SvgIcon viewBox={viewBox} {...rest}>
            <g>
                <g>
                    <polygon
                        fill="currentColor"
                        points="15.7,21.4 2.6,21.4 2.6,2.6 15.7,2.6 15.7,6.6 14.5,6.6 14.5,3.9 3.8,3.9 3.8,20.1 14.5,20.1
			14.5,18.3 15.7,18.3 		"
                    />
                </g>
                <g>
                    <rect x="6.6" y="11.8" fill="currentColor" width="14.2" height="1.2" />
                </g>
                <g>
                    <polygon fill="currentColor" points="10.3,17 5.7,12.4 10.3,7.8 11.2,8.7 7.4,12.4 11.2,16.2 		" />
                </g>
            </g>
        </SvgIcon>
    );
};
